import React from "react";
import TalentCard from "../app/TalentCard";
import toList from "../utils/ComponentUtil";
import CustomBreadcrumbs from "../utils/CustomBreadcrumbs";
import jobImg from "../../images/proof-reading.png";
import "./JobDesc.scss";


function JobDesc({ name, title, header = undefined, render = () => { }, breadcrumbs, compensation, editContent,
    contentToEditToday, contents = [], talents = [], talentsTitle, 
    component, startPosting = true, bannerImg = false, template = TalentCard }) {
    const isTalentsPresent = talents && talents.length;
    return (
        <div className="job-desc-wrp wrapper">
            {
                bannerImg && <div className="job-banner-wrp" >
                    <img src={jobImg} alt='jobName'></img>
                    <div className="title">Advertisement</div>
                </div>
            }
            <div className="job-desc-container">
                <div className="job-path-wrp">
                    <CustomBreadcrumbs breadcrumbs={breadcrumbs} />
                </div>
                {header && header}
                <div className={"job-desc-left" + (!isTalentsPresent ? ' full-width' : '')}>
                    {render(component, editContent, contents, compensation, title, contentToEditToday)}
                    {
                        startPosting && <div className="start-posting-banner-wrp">
                            <div className="post-talent-wrp">
                                <div className="post-talent-title">Post Your Talent And Earn Rs. 300 Instantly</div>
                                <div className="post-talent-subtitle">Earn More By Fixing Your Own Price For Your Work</div>
                            </div>
                            <div>
                                <div className="hbw-button">Start  Posting</div>
                            </div>
                        </div>
                    }
                </div>
                {isTalentsPresent ? <div className="job-desc-right">
                    <div className="job-desc-title">{talentsTitle}</div>
                        {toList([...talents], template)}
                </div> : <></>}
            </div>
        </div>
    );
}

export default JobDesc;